export default __webpack_public_path__ + "static/media/org-chart.9a981ead.webp";